import { useQuery } from "@tanstack/react-query";
import { useLocalLogic } from "~/context/LocalLogicProvider";
import { scoresResponse, scoresKeys } from "~/features/scores";

export function useScores({
  include,
  location,
  geographyId,
}: {
  include?: Partial<scoresResponse>["include"];
  location: {
    lat?: number;
    lng?: number;
  };
  geographyId?: string;
}) {
  const { client, locale } = useLocalLogic();
  const options: scoresResponse = {
    locationScoresRounding: false,
    include,
  };

  if (geographyId) {
    options.geographyIds = [geographyId];
  } else {
    options.lat = location.lat;
    options.lng = location.lng;
    options.geographyLevels = ["20", "30"];
  }

  return useQuery({
    queryKey: scoresKeys.list({ ...options, locale }),
    queryFn: async () => client.getScores(options),
    staleTime: Infinity,
    enabled: (!!location?.lat && !!location?.lng) || !!geographyId,
  });
}
